/** @format */
import styled from 'styled-components';

import { theme } from '@toucan/client/global/theme';

import { Link } from '@toucan/client/shared/components/link';

// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component, @mpb-com/mpb/styled-component-prefix -- Legacy code: do not use as an example.
export const MarketSelectorWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: var(--layout-spacing-8);
`;

// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component, @mpb-com/mpb/single-styled-component, @mpb-com/mpb/styled-component-prefix -- Legacy code: do not use as an example.
/* eslint-disable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component, @mpb-com/mpb/single-styled-component, @mpb-com/mpb/styled-component-prefix -- Legacy code: do not use as an example.
export const MarketSelectorLink = styled(Link)`
    ${theme.typography.body_small_highlight};
`;
/* eslint-enable @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example. */
